import { Howler } from "howler";
import * as PIXI from "pixi.js";

import "pixi-spine";

import { Application } from "./scripts/Application";

PIXI.glCore.VertexArrayObject.FORCE_NATIVE = true;
Howler.autoUnlock = false;
const canvasDiv = document.createElement("div");
canvasDiv.setAttribute("id", "gameTarget");
document.body.appendChild(canvasDiv);
canvasDiv.appendChild(Application.instance.view);

Application.instance.init();
